(function () {

    'use strict';

    angular
        .module('app.staticpage')
        .controller('StaticPageController', [
            '$scope',
            '$route',
            '$routeParams',
            '$location',
            'ApiService',
            'GaService',
            '$timeout',
            StaticPageController]
        );

    function StaticPageController($scope, $route, $routeParams, $location, apiService, gaService, $timeout) {

        var currentPageName = $route.current.page;
        var isBanner = $route.current.banner;
        var isDefaultLayout = $route.current.defaultLayout;
        var isGeneric = $route.current.isGeneric;
        var locationPath = 'common/' + $routeParams.langCode;

        init();

        function init() {

            if (!isGeneric) {
                locationPath = 'locations/' + $routeParams.locCode + '/' + $routeParams.langCode;
            }
            
            if ($routeParams.locCode=='richmond' && (currentPageName === "HowToBuy" || currentPageName === "HowToSell")) {
                locationPath = 'locations/' + $routeParams.locCode + '/' + $routeParams.langCode;
            }

            $scope.isBanner = isBanner;
            $scope.locationPath = locationPath;
            $scope.currentPageName = currentPageName;
            $scope.isDefaultLayout = isDefaultLayout;
            $scope.location = $routeParams.locCode;

            if (angular.isDefined($routeParams.locCode) && angular.isDefined($routeParams.langCode)) {
                $timeout(function() {
                    gaService.gaTrackPageViewAsync($location.path().toString(), currentPageName);
                }, 1000);
                apiService.getLocations($routeParams.langCode).then(function (response) {
                    var locationInfo = apiService.getLocationByCode(response.data, $routeParams.locCode);
                    if (currentPageName === "HowToBuy") {
                        if (angular.isDefined(locationInfo)) {
                            $scope.inPersonBuyerRegistrationFormUrl = locationInfo.inPersonBuyerRegistrationFormUrl || '';
                            $scope.publicAuctionPoliciesUrl = locationInfo.publicAuctionPoliciesUrl || '';
                            $scope.onlineBuyerRegistrationFormUrl = locationInfo.onlineBuyerRegistrationFormUrl || '';
                            $scope.logInUrl = locationInfo.logInUrl || '';
                        }
                    } else if (currentPageName === "HowToSell") {
                        if (angular.isDefined(locationInfo)) {
                            $scope.sellerRegistrationFormUrl = locationInfo.sellerRegistrationFormUrl || '';
                        }
                    }
                });
            }
        }

    }

})();


// WEBPACK FOOTER //
// ./app/staticpage/StaticPageController.js